import React from 'react';
import LineBreak from '../LineBreak';
import styles from './CombineSection.module.scss';
import analogTechTitle from '../../images/analog-tech-title.svg';
import digitalTechTitle from '../../images/digital-tech-title.svg';

function CombineSection() {
  return (
    <div className={styles.combine}>
      <div className={styles.container}>
        <h2>COMBINAMOS</h2>
        <div className={styles.content}>
          <div className={styles.plus}>+</div>

          <div className={styles.techBox}>
            <div className={styles.label}>
              <img src={analogTechTitle} alt="Tecnologia Analógica" />
            </div>
            <div className={styles.imageBox}>
              {/* Gray box for analog tech */}
            </div>
            <p>
              Massinhas, Almanaques,
              <LineBreak />
              Figurinhas, Produtos Físicos
            </p>
          </div>

          <div className={styles.techBox}>
            <div className={styles.label}>
              <img src={digitalTechTitle} alt="Tecnologias Digitais" />
            </div>
            <div className={styles.imageBox}>
              {/* Gray box for digital tech */}
            </div>
            <p>
              Aplicativo móvel, análise de
              <LineBreak />
              dados, relatórios
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CombineSection;
